<template>
  <div class="p_supply_module p_fee_module">
    <div class="topOperation">
        <div class="top-left">
            <ShowNavHead />
            <div class="screenInputs">
                <div class="screenInput">
                    <div class="flname">施工队名称</div>
                    <el-input v-model="listQuery.strConstrteamName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <div class="screenInput">
                  <div class="flname">认证状态</div>
                  <el-select v-model="listQuery.strExamStatus" size="small" placeholder="" clearable="">
                    <el-option label="已认证" value="已认证"></el-option>
                    <el-option label="认证失败" value="认证失败"></el-option>
                    <el-option label="重新认证" value="重新认证"></el-option>
                  </el-select>
                </div>
                <!-- <div class="screenInput">
                    <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
                    <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
                    </el-tooltip>
                </div> -->
            </div>
        </div>
        <div class="top-right">
            <el-button v-if="showDropScreen==-1" :disabled="isSearchHandle" type="success" size="small" @click="searchHandle" style="margin-right:24px">搜索</el-button>
        </div>
    </div>
    <!-- 筛选下拉框 -->
    <!-- <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
          <el-form-item label="任务:">
            <el-select v-model="listQuery.bolUserSex" size="small" placeholder="">
              <el-option label="普工采集" value="普工采集"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="采集平台:">
            <el-select v-model="listQuery.pingtai" size="small" placeholder="">
              <el-option label="宁波人才网" value="宁波人才网"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上班地点:">
            <el-input v-model="listQuery.area" size="small" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
          <el-button size="small" plain @click="resetHandle()">清空</el-button>
          <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
          <el-button :disabled="isSearchHandle" size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div> -->
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>灵活用工</el-breadcrumb-item>
          <el-breadcrumb-item>{{pageCrumb}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_clue_box re_table_remind" v-loading="tableLoading">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane v-if="checkPermission(['supplierManage_tab_list'],permissionLists)" label="施工队列表" name="first"></el-tab-pane>
                <el-tab-pane v-if="checkPermission(['supplierManage_tab_remind'],permissionLists)" label="施工队提醒" name="second"></el-tab-pane>
                <el-tab-pane v-if="checkPermission(['supplierManage_tab_recertification'],permissionLists)" label="施工队重新认证列表" name="third"></el-tab-pane>
          </el-tabs>
        <el-table ref="clueTable" class="re_table" :header-cell-style="{background:'#f2f2f2',color: '#909399'}" border :highlight-current-row="true" :max-height="tableHeight-100" :data="tableData" style="width:100%">
            <el-table-column align="center" label="施工队编号" fixed min-width="130px" fit show-overflow-tooltip>
                <template slot-scope="{row}">
                    <span>{{row.StrConstrteamCode}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="施工队名称" fixed min-width="130px" fit show-overflow-tooltip>
                <template slot-scope="{row}">
                    <span>{{row.StrConstrteamName}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="状态" min-width="100px" fit show-overflow-tooltip>
                <template slot-scope="{row}">
                    <span>{{row.StrExamStatus}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="申请时间" min-width="120px" fit show-overflow-tooltip>
                <template slot-scope="{row}">
                    <span>{{row.DtRecerDate}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="申请备注" min-width="160px" fit show-overflow-tooltip>
                <template slot-scope="{row}">
                    <span>{{row.StrRecertificaRemark}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="认证备注" min-width="160px" fit show-overflow-tooltip>
                <template slot-scope="{row}">
                    <span>{{row.StrExamRemark}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" fixed="right" width="180px">
                <template slot-scope="{row}">
                    <el-button v-if="checkPermission(['recertification_dtl'],permissionLists)" type="info" size="mini" plain @click="dtlHandle(row)">详情</el-button>
                    <el-button v-if="(row.StrExamStatus == '申请重新认证')&&(checkPermission(['recertification_apply'],permissionLists))" type="info" size="mini" plain @click="applyHandle(row)">处理申请</el-button>
                    <el-button v-if="(row.StrExamStatus == '重新认证')&&(checkPermission(['recertification_attestation'],permissionLists))" type="info" size="mini" plain @click="authHandle(row)">处理认证</el-button>
                </template>
            </el-table-column>
          </el-table>
          <div class="block">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="listQuery.currpage"
              :page-size="listQuery.perpage"
              @size-change="handleSizeChange"
              :page-sizes="[10, 20, 50, 100, 200]"
              layout="total,sizes,prev,pager,next,jumper"
              :total="total"
            ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 修改认证状态弹框 -->
    <el-dialog title="修改认证状态" :visible.sync="identifyVisible" width="600px" class="res_dialog">
        <el-form :model="recertifyQuery" :rules="recertifyRules" ref="dtreachForm" class="re_dialog_form" label-width="130px">
            <el-form-item label="认证状态:" prop="StrRecertificaStatus">
                <el-select v-model="recertifyQuery.StrRecertificaStatus" placeholder="" size="small">
                    <el-option label="已认证" value="已认证"></el-option>
                    <el-option label="认证失败" value="认证失败"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="备注:" prop="StrExamRemark" v-if="recertifyQuery.StrRecertificaStatus == '认证失败'">
                <el-input v-model="recertifyQuery.StrExamRemark" type="textarea" size="small" clearable></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button
                @click="identifyVisible = false"
                size="small"
                >取消</el-button>
            <el-button
                type="primary" class="com_dialog_btn"
                @click="saveIdentifyHandle"
                size="small"
                >确定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        //禁用日期范围
        pickerOptions: {
            disabledDate(time) {
            return time.getTime() > Date.now();
            }
        },
        // 表头参数
        titleQuery:{
          strTableId:'JB_busi_ConstrTeam', //JB_busi_UtilityBill (费用单) JB_busi_ConstrPerson（施工人员）JB_busi_ConstrTeam（施工队）JB_report_Receivables  应收款报表
          strIsFixed:''
        },
        activeName:'third',
        teamList:[],//施工队列表
        tableHeight: 0,
        showDropScreen:-1,
        pageCrumb:'施工队重新认证列表',
        tableData: [],
        listQuery:{
          strConstrteamName:'',// 施工队名称
          strConstrteamCode:'',
          strExamStatus:'',
          currpage:1,
          perpage:10
        },
        custPath: '',//导出文件下载路径
        isSearchHandle:false,
        tableLoading:false,
        // 表头数据
        tableTitle:[],
        total:0,
        tablePath: this.$store.state.EMP.tablePath,
        //角色类型
        roleType: '',
        recertifyRules: {
          StrRecertificaStatus: [
              { required: true, message: '请选择认证状态', trigger: 'change' }
          ],
          StrExamRemark: [
              { required: true, message: '请输入原因', trigger: 'blur' }
          ]
      },
        identifyVisible:false,
        recertifyQuery:{
            GdreceId:'',
            GdteamId:'',
            StrConstrteamCode:'',
            StrRecertificaRemark:'',
            StrExamRemark:'',//处理认证失败时 原因
            StrRecertificaStatus:''//重新认证 已上传认证 已认证 认证失败
        },
        // 按钮权限参数
        butQuery:{
          path:'/supplierManage',
          powerEnName:'supplierManage'
        },
        permissionLists:[]
      }
    },
    created() {
        this.calHeight();
        this.getButtonPower()
        this.roleType = localStorage.loginRoletype
        if(!this.isNull(this.$route.query.code)){
            this.listQuery.strConstrteamCode = this.$route.query.code
        }
        if(!this.isNull(this.$route.query.active)){
          this.activeName = this.$route.query.active
          if(this.activeName == 'third'){
            // 表头
            this.getTableTitleLists()
          }
        }
    },
    methods: {
      checkPermission,
    // 获取按钮权限
    getButtonPower(){
      xz.getbtnPowerIdBypage(this.butQuery).then(res => {
        // console.log('按钮',res)
        if(res.status == 'ok'){
          let resmsg = res.msg
          if(!this.isNull(resmsg)){
            for (let index = 0; index < resmsg.length; index++) {
              let element = resmsg[index];
              this.permissionLists.push(element.Enname);
            }
            if(this.checkPermission(['supplierManage_tab_list'],this.permissionLists)&&(this.isNull(this.$route.query.active))){
              this.activeName = 'first'
              this.$router.push({
                  path: '/supplierManage'
              })
            }else if((!this.checkPermission(['supplierManage_tab_list'],this.permissionLists))&&(this.checkPermission(['supplierManage_tab_remind'],this.permissionLists))&&(!this.checkPermission(['supplierManage_tab_recertification'],this.permissionLists))&&(this.isNull(this.$route.query.active))){
              this.activeName = 'second'
              this.$router.push({
                  path: '/teamReminder',
                  query:{
                      jumpname:'team'
                  }
              })
            }else if((!this.checkPermission(['supplierManage_tab_list'],this.permissionLists))&&(!this.checkPermission(['supplierManage_tab_remind'],this.permissionLists))&&(this.checkPermission(['supplierManage_tab_recertification'],this.permissionLists))&&(this.isNull(this.$route.query.active))){
              this.activeName = 'third'
              // 表头
              this.getTableTitleLists()
            }
          }else{
            this.permissionLists = []
            this.activeName = ''
          }
        }else{
          this.permissionLists = []
          this.activeName = ''
        }
      })
    },
        calHeight() {
            this.tableHeight = Number(document.body.clientHeight);
            // console.log('height', this.tableHeight)
        },
        handleClick(tab, event) {
            // console.log(tab, event);
            this.activeName = tab.name
            if(tab.name == 'second'){
              this.$router.push({
                path: '/teamReminder',
                query: {
                  jumpname: 'team',
                  active:'second'
                }
              })
            }else if(tab.name == 'first'){
              this.$router.push({
                path: '/supplierManage',
                active:'first'
              })
            }
        },
        // 详情
        dtlHandle(row){
          let routeUrl = this.$router.resolve(
            { path: '/supplyDetail',query:{
              id: row.GdteamId
            }
          });
          window.open(routeUrl.href, '_blank');
        },
        // 处理申请
        applyHandle(row){
            let that = this
            this.recertifyQuery.GdreceId = row.GdreceId
            this.recertifyQuery.GdteamId = row.GdteamId
            this.recertifyQuery.StrConstrteamCode = row.StrConstrteamCode
            this.recertifyQuery.StrRecertificaRemark = row.StrRecertificaRemark
            this.recertifyQuery.StrExamRemark = ''
            this.recertifyQuery.StrRecertificaStatus = '重新认证'
            this.$confirm('是否通过此申请?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.saveAuthHandle()
            })
        },
        // 处理认证
        authHandle(row){
            this.recertifyQuery.GdreceId = row.GdreceId
            this.recertifyQuery.GdteamId = row.GdteamId
            this.recertifyQuery.StrConstrteamCode = row.StrConstrteamCode
            this.recertifyQuery.StrRecertificaRemark = row.StrRecertificaRemark
            this.recertifyQuery.StrRecertificaStatus = ''
            this.identifyVisible = true
        },
        // 确定认证
        saveIdentifyHandle(){
            let that = this
            this.$refs['dtreachForm'].validate((valid) => {
                if (valid) {
                    // console.log('fff',this.recertifyQuery)
                    that.saveAuthHandle()
                }
            })
        },
        // 处理申请和认证
        saveAuthHandle(){
            xz.applyConstrTeamRecertif(this.recertifyQuery).then(res => {
                if (res.status == 'ok') {
                    this.identifyVisible = false
                    this.getList()
                    this.$message({ type: 'success', message: '操作成功' })
                }else{
                    this.$message({ type: 'error', message: res.msg })
                }
            })
        },
        // 获取表头
        getTableTitleLists(){
          xz.getEcustColumnList(this.titleQuery.strTableId,this.titleQuery.strIsFixed).then(res => {
            if (res.status == 'ok') {
              this.tableTitle = res.msg
              this.getList()
            }else{
              this.tableTitle = []
            }
            // console.log('表头', res)
          })
        },
        // 获取列表
        getList(){
            this.tableLoading = true
            this.isSearchHandle = true
            xz.getConstrTeamRecertif(this.listQuery).then(res => {
                // console.log('getList', res)
                if (res.status == 'ok') {
                    this.tableData = res.msg
                    this.total = res.totalcount
                }else{
                    this.tableData = []
                    this.total = 0
                }
                this.tableLoading = false
                this.isSearchHandle = false
            })
        },
        //分页
        handleCurrentChange(val){
            this.listQuery.currpage = Number(val)
            this.getList()
        },
        handleSizeChange(val) {
            this.listQuery.currpage = 1
            this.listQuery.perpage = Number(val)
            this.getList()
        },
        calDaysBetween(date) {
            let startDate = Date.parse(date);
            let endDate = Date.parse(new Date());
            let days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
            days > 7 ? this.isDownFeeTemplate = false : this.isDownFeeTemplate = true;
        },
        // 获取施工队列表
        getTeamList(){
            xz.getConstrTeamLists(this.teamQuery).then(res => {
              // console.log('getList', res)
              if (res.status == 'ok') {
                  this.teamList = res.msg
                }else{
                  this.teamList = []
                }
            })
        },
        // 搜索
        searchHandle(){
            this.listQuery.currpage = 1
            this.getList()
        },
        // 清空
        resetHandle(){
          this.listQuery = this.$options.data.call(this).listQuery
        },
        //筛选下拉
        dropDownScreen() {
            if (this.showDropScreen == -1) {
            this.showDropScreen = 1;
            } else if (this.showDropScreen == 1) {
            this.showDropScreen = -1;
            }
        },
        //判断是否为空(包含0)
        isNull(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN';
        }
    }
  }
</script>

<style scoped>
.p_clue_box{
    background-color: #fff;
}
.r_act_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  justify-content: flex-end;
  padding: 15px 15px;
}
.r_act_left{
  display: flex;
  align-items: center;
}
.r_act_item{
  display: flex;
  align-items: center;
  margin-left: 8px;
}
.scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
}
.main-con {
    background-color: #f3f3f3;
    padding: 0px 15px 15px;
    overflow-x: hidden;
    overflow-y: auto;
}
.r_dropDownScreen{
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
}
.re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
}
.com_dialog_btn.el-button{
  background-color: #ebfaf5;
  border: 1px solid #62d2b4;
  color: #19BD92;
  font-weight: bold;
}
.com_dialog_btn.el-button:hover{
  background-color: #19BD92;
  border: 1px solid #62d2b4;
  color: #fff;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}
.steps-box {
  margin-top: 20px;
}
.steps-box .el-step__title {
  font-size: 14px;
  color: #999;
}
.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-box {
  position: relative;
}
.file-btn {
  display: inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  /* border-radius:2px; */
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  /* position: absolute;
    top: 5px;
    right: 0; */
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<style>
.p_supply_module .el-form-item__label{
  padding: 0 5px 0 0;
}
.p_supply_module .el-tabs{
    background-color: #fff;
}
.p_supply_module .el-tabs.p_mem_tabs{
    padding: 0 10px;
}
.p_supply_module .screenInputs .screenInput {
  margin: 0 0 10px 5px;
}
.p_supply_module .screenInputs .screenInput .el-select .el-input__inner,
.p_supply_module .re_down_form.el-form--inline .el-form-item__content,
.p_supply_module .re_down_form .el-select,
.p_supply_module .re_down_form .el-form-item__content,
.p_supply_module .screenInput .el-input{
  width: 200px;
}
.re_table.el-table .cell{
padding: 0 5px;
}
.re_table.el-table .el-table__cell{
padding: 3px 0;
}
</style>